<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>{{ "MasterData.Currencies.CreateTitle" | i18nextEager }}</ng-template>
  <ng-template #content>
    <form [formGroup]="form">
      <doka-text-field
        class="w-full"
        formControlName="isoCurrencyCode"
        [label]="'MasterData.Currencies.Code' | i18nextEager"
        [placeholder]="'MasterData.Currencies.CodePlaceholder' | i18nextEager"
        [alert]="
          form.controls.isoCurrencyCode.touched && form.controls.isoCurrencyCode.invalid
            ? ('MasterData.Currencies.InvalidCode' | i18nextEager)
            : ''
        "
      />
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
      <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">
        {{ "Common.Cancel" | i18nextEager }}
      </doka-button>
      <doka-button [disabled]="form.invalid || isLoading()" (click)="submit()" color="primary">
        {{ "Common.Save" | i18nextEager }}
      </doka-button>
    </div>
  </ng-template>
</doka-modal-wrapper>
